import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "report", "resolver", "value"];
import { useCallback } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Small } from 'foundations-components/transitional/components/Small';
import ReferenceLiteSearchSelect from 'reference-resolvers-lite/components/ReferenceLiteSearchSelect';
import { SALES_QUOTA_NO_PIPELINE_VALUE } from './quickFilterEditorUtils';
import { getDimensions } from 'reporting-data/report/configReportGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const filterPipelineOptions = (option, filterValue) => {
  if (option.value === SALES_QUOTA_NO_PIPELINE_VALUE) return false;
  const filterTest = filterValue.toLocaleLowerCase();
  const valueTest = String(option.value).toLocaleLowerCase();
  const labelTest = (option.text || '').toLocaleLowerCase();
  return valueTest.includes(filterTest) || labelTest.includes(filterTest);
};
const filterAndModifyPipelineOptions = (options, filterValue, isNoPipelineSelected) => {
  const filteredOptions = options.filter(option => filterPipelineOptions(option, filterValue));
  return filteredOptions.map(option => ({
    disabled: isNoPipelineSelected,
    text: option.text,
    value: option.value
  }));
};
const Footer = ({
  checked,
  onChange
}) => /*#__PURE__*/_jsx(Checkbox, {
  checked: checked,
  onChange: ({
    target: {
      checked: isChecked
    }
  }) => {
    onChange(isChecked ? SALES_QUOTA_NO_PIPELINE_VALUE : null);
  },
  description: /*#__PURE__*/_jsx(Small, {
    use: "help",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingLabels.quickFilter.customWidget.salesQuota.noPipelineDescription"
    })
  }),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "settingLabels.quickFilter.customWidget.salesQuota.noPipelineLabel"
  })
});
const SalesQuotaPipelineSelect = _ref => {
  let {
      onChange,
      report,
      resolver,
      value
    } = _ref,
    selectProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const clearable = !getDimensions(report).includes('dealstage');
  const isNoPipelineSelected = value === SALES_QUOTA_NO_PIPELINE_VALUE;
  const filterOptions = useCallback((options, filterValue) => filterAndModifyPipelineOptions(options, filterValue, isNoPipelineSelected), [isNoPipelineSelected]);
  return /*#__PURE__*/_jsx(ReferenceLiteSearchSelect, Object.assign({}, selectProps, {
    clearable: clearable,
    dropdownFooter: /*#__PURE__*/_jsx(Footer, {
      checked: isNoPipelineSelected,
      onChange: onChange
    }),
    filterOptions: filterOptions,
    options: [{
      text: I18n.text('settingLabels.quickFilter.customWidget.salesQuota.noPipelineLabel'),
      value: SALES_QUOTA_NO_PIPELINE_VALUE
    }],
    onChange: ({
      target: {
        value: newValue
      }
    }) => {
      onChange(newValue);
    },
    resolver: resolver,
    value: value
  }));
};
export default SalesQuotaPipelineSelect;